import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {
  CustomProffixService, StundenAntrag, UserSessionService, AbwesenheitsAntrag
} from '../../services';

import {
  StundenartService,
  Stundenart
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-existing-requests',
  templateUrl: './existing-requests.component.html',
  styleUrls: ['./existing-requests.component.css']
})
export class ExistingRequestsComponent implements OnInit {

  @Input() linkText: string;
  @Input() titleText: string;
  @Input() mitarbeiterNr: number;
  @Input() datumVon: string;
  @Input() datumBis: string;
  @Input() antragId = '';
  @Input() abwesenheitId = '';

  isLoaded = false;
  stundenAntraegeList: StundenAntrag[];
  listOfAbwesenheitsAntraege: AbwesenheitsAntrag[];
  listOfStundenarten: Stundenart[];

  constructor(
    private _customProffixService: CustomProffixService,
    private _userSessionService: UserSessionService,
    private _stundenartService: StundenartService,
    private _modalService: NgbModal,
  ) { }

  ngOnInit() {
  }

  private getDateStringFromDate(date: Date): string {
    let result = '';

    result += date.getFullYear() + '-';
    if (date.getMonth() < 9) { result += '0'; }
    result += (date.getMonth() + 1) + '-';
    if (date.getDate() < 10) { result += '0'; }
    result += date.getDate();

    return result;
  }

  public getStundenartBezeichnung(stundenartNr: string): string {
    if (this.listOfStundenarten !== undefined) {
      const sa = this.listOfStundenarten.find(x => x.StundenartNr === stundenartNr);

      if (sa !== undefined) {
        return sa.Bezeichnung;
      }
    }

    return '';
  }

  public showExistingRequests(content: any) {
    this.isLoaded = false;
    this._userSessionService.getProffixLogin().subscribe(data => {
      const filterDatumVon = new Date(this.datumVon);
      const filterDatumBis = new Date(this.datumBis);

      this._customProffixService.getStundenAntrag(
        {
          sort: '-StartZeit',
          limit: 10,
          offset: 0,
          filter: 'MitNrPRO==' + this.mitarbeiterNr.toString()
          + ',' + 'Id!="' + this.antragId + '"'
          + ',' + 'Datum>=D"' + this.getDateStringFromDate(filterDatumVon) + '"'
          + ',' + 'Datum<=D"' + this.getDateStringFromDate(filterDatumBis) + '"',
        }).subscribe((result) => {
          this.stundenAntraegeList = result;

          return this._customProffixService.getAbwesenheitsAntraege(
            {
              sort: '-StartDatum',
              limit: 10,
              offset: 0,
              filter: 'MitNrPRO==' + this.mitarbeiterNr.toString()
              + ',' + 'Id!="' + this.abwesenheitId + '"'
              + ',' + 'StartDatum<=D"' + this.getDateStringFromDate(filterDatumVon) + '"'
              + ',' + 'EndDatum>=D"' + this.getDateStringFromDate(filterDatumBis) + '"',
            }).subscribe((abwesenheitResult) => {
              this.listOfAbwesenheitsAntraege = abwesenheitResult;

              this._stundenartService.getAll({}).subscribe(stundenartResult => {
                this.listOfStundenarten = stundenartResult;
                this.isLoaded = true;

                this._modalService.open(content, { size: 'lg' });
              });
            });
        });
    });
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/partials/existing-requests/existing-requests.component.ts